import ProductGrid from './ProductGrid';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import formatPrismicData from '../../hocs/formatPrismicData';
import { withModel } from '../../data-providers/model';
import {
  getAvailableProductIds,
  findLowestProductPrice
} from 'src/common/utils/product';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import withCountry from '../../hocs/withCountry';
import withMedia from 'src/client/js/view/hocs/withMediaQueries';
import withState from 'recompose/withState';
import get from 'lodash/get';

const enhance = compose(
  formatPrismicData,
  withModel,
  withCountry,
  withProps(props => {
    const {
      eagleModel: { products },
      countryModel
    } = props.model;

    const availableProductIds = getAvailableProductIds(products);

    return {
      products,
      availableProductIds,
      items: props.items
        .filter(item =>
          availableProductIds.includes(item.product.main.productId)
        )
        .map(item => ({
          ...item,
          ...findLowestProductPrice(products, item.product.main.productId),
          url: localiseUrl(
            countryModel,
            `/personalized-products/${item.product.productInformation.productSlug}`
          )
        }))
        .filter(item => item.price)
    };
  }),
  withState('expandedId', 'setExpandedId', props =>
    get(props, 'expandedId', null)
  ),
  withMedia
);

export default enhance(ProductGrid);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductGrid/index.js